import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

const disabled = fieldConfig({ inputProps: { disabled: true } });

/** UpdateMatchCommand: curator-owned fields only (MATCH_EDITABLE). Kickoff, state, scores,
 *  round and season belong to TINA's /sync and are shown read-only on the page. */
export const matchEditSchema = z.object({
  id: z.string().nullish().superRefine(disabled),
  status: z.enum(["Draft", "Complete", "Hidden"]),
  hide: z.boolean().default(false),
  tags: z
    .array(z.string())
    .nullish()
    .default([])
    .superRefine(fieldConfig({ fieldType: "tagList" })),
  ticketUrl: z
    .string()
    .url("Must be an http(s) link")
    .refine((u) => /^https?:\/\//i.test(u), "Must be an http(s) link")
    .nullish()
    .superRefine(fieldConfig({ label: "Ticket URL" })),
  pricing: z
    .array(
      z.object({
        label: z.string().min(1, "Required"),
        amount: z.coerce.number().min(0),
        currency: z
          .string()
          .regex(/^[A-Z]{3}$/, "Must be a 3-letter ISO 4217 code")
          .default("EUR"),
      }),
    )
    .nullish()
    .default([]),
  venueId: z
    .string()
    .nullish()
    .superRefine(
      fieldConfig({
        fieldType: "matchVenue",
        label: "Venue",
        description:
          "Choosing a venue here fixes it: TINA will not change it any more. It cannot be set back to automatic from IMS.",
      }),
    ),
});
export type MatchEditType = z.infer<typeof matchEditSchema>;
